import Vue from 'vue';
import VueRouter from 'vue-router';
import axios from '@/api/request';
import store from '@/store/index.js';

Vue.use(VueRouter)

const routes = [{
  path: '/error',
  name: 'error',
  component: function () {
    return import('../views/error/index.vue')
  },
  meta: {
    title: 'error'
  }
},
// {
//   path: '/',
//   name: 'home',
//   component: function () {
//     return import('../views/Home/index.vue')
//   },
//   meta: {
//     title: '首页'
//   }
// },
{
  path: '/',
  name: 'home',
  component: function () {
    return import('../views/workbench/index.vue')
  },
  meta: {
    title: '工作台'
  }
},
{
  path: '/login',
  name: 'login',
  component: function () {
    return import('../views/Login/index.vue')
  },
  meta: {
    title: '登录'
  }
},
{
  path: '/kefulist',
  name: 'kefuList',
  component: function () {
    return import('../views/kefuList/index.vue')
  },
  meta: {
    title: '客服列表'
  }
},
{
  path: '/sitelist',
  name: 'siteList',
  component: function () {
    return import('../views/siteList/index.vue')
  },
  meta: {
    title: '站点列表'
  }
},
{
  path: '/sitepage',
  name: 'sitePage',
  component: function () {
    return import('../views/siteList/sitePage.vue')
  },
  meta: {
    title: '站点和页面'
  }
},
{
  path: '/siteDetails',
  name: 'siteDetails',
  component: function () {
    return import('../views/siteList/siteDetails.vue')
  },
  meta: {
    title: '站点详情'
  }
},
{
  path: '/chatlist',
  name: 'chatList',
  component: function () {
    return import('../views/chatList/index.vue')
  },
  meta: {
    title: '访客列表'
  }
},
{
  path: '/documentlist',
  name: 'documentList',
  component: function () {
    return import('../views/documentList/index.vue')
  },
  meta: {
    title: '文档列表'
  }
},
{
  path: '/documentDetails',
  name: 'documentDetails',
  component: function () {
    return import('../views/documentList/documentDetails.vue')
  },
  meta: {
    title: '文档详情'
  }
},
{
  path: '/accountlist',
  name: 'accountList',
  component: function () {
    return import('../views/adminPage/accountList.vue')
  },
  meta: {
    title: '账户列表'
  }
},
{
  path: '/blocklist',
  name: 'blockList',
  component: function () {
    return import('../views/blockList/index.vue')
  },
  meta: {
    title: '黑名单'
  }
},
{
  path: '/recordlist',
  name: 'recordList',
  component: function () {
    return import('../views/recordList/index.vue')
  },
  meta: {
    title: '会话记录'
  }
},
{
  path: '/aidate',
  name: 'aiDate',
  component: function () {
    return import('../views/aiDate/index.vue')
  },
  meta: {
    title: 'AI资料库'
  }
},
{
  path: '/aistudy',
  name: 'aiStudy',
  component: function () {
    return import('../views/aiStudy/index.vue')
  },
  meta: {
    title: 'AI学习'
  }
},
{
  path: '/formlist',
  name: 'formList',
  component: function () {
    return import('../views/formList/index.vue')
  },
  meta: {
    title: '表单列表'
  }
},
//新加
{
  path: '/customermanagement',
  name: 'customerManagement',
  component: function () {
    return import('../views/customerManagement/index.vue')
  },
  meta: {
    title: '用户管理'
  }
},
{
  path: '/visitormanagement',
  name: 'visitorManagement',
  component: function () {
    return import('../views/chatList/index.vue')
  },
  meta: {
    title: '访客管理'
  }
},
{
  path: '/sessionmanagement',
  name: 'sessionManagement',
  component: function () {
    return import('../views/recordList/index.vue')
  },
  meta: {
    title: '会话管理'
  }
},
{
  path: '/statistics/users',
  name: 'usersStatistics',
  component: function () {
    return import('../views/statistics/users/index.vue')
  },
  meta: {
    title: '用户统计'
  }
},
{
  path: '/statistics/visitors',
  name: 'visitorsStatistics',
  component: function () {
    return import('../views/statistics/visitors/index.vue')
  },
  meta: {
    title: '访客统计'
  }
},
{
  path: '/authority/role',
  name: 'roleList',
  component: function () {
    return import('../views/authority/role/index.vue')
  },
  meta: {
    title: '角色列表'
  }
},
{
  path: '/authority/user',
  name: 'userList',
  component: function () {
    return import('../views/authority/user/index.vue')
  },
  meta: {
    title: '用户列表'
  }
},
{
  path: '/authority/updatelog',
  name: 'updateLog',
  component: function () {
    return import('../views/authority/updateLog/index.vue')
  },
  meta: {
    title: '更新日志'
  }
},
{
  path: '/authority/updatelog/add',
  name: 'addUpdateLog',
  component: function () {
    return import('../views/authority/updateLog/Add/index.vue')
  },
  meta: {
    title: '添加更新日志'
  }
},
//菜单列表
{
  path: '/menu',
  name: 'menuList',
  component: function () {
    return import('../views/menu/index.vue')
  },
  meta: {
    title: '菜单列表'
  }
}
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // 设置网站 title 名称
  const auth = localStorage.getItem('auth');
  let RoleName = "";
  if (auth == 'user') {
    RoleName = "客户后台";
  } else if (auth == "cs") {
    RoleName = "客服后台";
  }
  if (to.meta.title) {
    document.title = `${to.meta.title} - IM客服管理系统 ${RoleName}` || "IM客服管理系统";
  }

  // 处理携带 kct 的一次性登录
  if (to.query.kct) {
    const kct = to.query.kct;
    axios.get(`/api/IMAPI/getLoginInfo?kct=${kct}`)
      .then(response => {
        if (response.data.code == 200) {
          localStorage.setItem('aicsMng_token', response.data.data.access_token);
          localStorage.setItem('auth', response.data.data.profile.auth);

          // 异步刷新用户信息
          axios.get(`/customer/index`)
            .then(res => {
              if (res.data.code == 200) {
                store.commit("setUserData", res.data.data);
              }
            })
            .catch(err => {
              console.error(err);
            });

          // 清除查询参数，避免携带 kct 的重复进入
          const cleanedPath = location.hash.replace(/^#/ig, '').split('?')[0];
          if (cleanedPath !== to.path) {
            return next({ path: cleanedPath, replace: true });
          }
          return next();
        } else {
          return next('/login');
        }
      })
      .catch(error => {
        console.error(error);
        return next('/login');
      });
    return;
  }

  // 常规鉴权：允许进入 /login；其它路由需 token
  const aicsMng_token = localStorage.getItem('aicsMng_token');
  if (to.path === '/login') {
    return aicsMng_token ? next('/') : next();
  }
  return aicsMng_token ? next() : next('/login');
});

// 添加错误处理逻辑
// router.onError(error => {
//   if (error.response) {
//     const status = error.response.status;

//     if (status === 500) {
//       router.push({
//         name: 'error'
//       }).catch(err => {
//         console.error('Navigation error:', err);
//         // 处理导航错误
//       });
//     }

//     if (status === 401) {
//       router.push('/login').catch(err => {
//         console.error('Navigation error:', err);
//         // 处理导航错误
//       });
//     }
//   } else {
//     console.error('Unexpected error:', error);
//     // 处理没有response的错误
//   }
// });



export default router;